import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "text-xxs" }
const _hoisted_2 = { class: "flex align-items-start w-fit" }
const _hoisted_3 = {
  key: 0,
  class: "mr-2 shrink-0"
}

import { toRefs, ref } from 'vue';
import PreviewFileModal from '@/components/MessageCenter/components/Chat/components/PreviewFileModal.vue';
import PreviewMessageFile from '@/components/MessageCenter/components/Chat/components/PreviewMessageFile.vue';
import MessageActions from '@/components/MessageCenter/components/Chat/components/MessageActions.vue';
import { EMIT, PERMISSIONS } from '@/enum';
import { can, useDateTime } from '@/composables';

interface PropsInterface {
  createdAt: Date | string;
  content: string | null;
  attachments?: string[];
  displayName: string;
  isYou: boolean;
  messageId?: number;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Message',
  props: {
    createdAt: {},
    content: {},
    attachments: {},
    displayName: {},
    isYou: { type: Boolean },
    messageId: {}
  },
  setup(__props: any) {

const props = __props;
const { createdAt, content, displayName, isYou, messageId, attachments } = toRefs(props);
const showPreviewModal = ref(false);

const openFilePreview = () => {
  if (can([PERMISSIONS.MESSAGE_DOWNLOAD_MESSAGE_FILE])) showPreviewModal.value = true;
};

const closeFilePreview = () => {
  showPreviewModal.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-column my-2", _unref(isYou) ? 'align-items-end' : 'align-items-start'])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex align-items-center w-fit my-1", !_unref(isYou) ? 'flex-row-reverse' : ''])
    }, [
      _createElementVNode("p", _hoisted_1, _toDisplayString(_unref(useDateTime)().formatDateTimeForMessageFromUTC(_unref(createdAt))), 1),
      _createElementVNode("p", {
        class: _normalizeClass(["font-bold", _unref(isYou) ? 'ml-2' : 'mr-2'])
      }, _toDisplayString(_unref(isYou) ? 'You' : _unref(displayName)), 3)
    ], 2),
    _createElementVNode("div", _hoisted_2, [
      (_unref(isYou) && _unref(can)([_unref(PERMISSIONS).MESSAGE_DESTROY]))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(MessageActions, {
              "message-id": _unref(messageId),
              "created-at": _unref(createdAt),
              action: _unref(EMIT).DELETE_MESSAGE
            }, null, 8, ["message-id", "created-at", "action"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["bg-white p-2 text-sm border-round-xs border-round-bottom-md word-break max-w-17rem", _unref(isYou) ? 'border-round-left-md' : 'border-round-right-md'])
      }, [
        _createTextVNode(_toDisplayString(_unref(content)) + " ", 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(attachments), (attachment, index) => {
          return (_openBlock(), _createBlock(PreviewMessageFile, {
            key: index,
            file: attachment,
            "preview-file": true,
            "document-id": attachment.id,
            "message-id": _unref(messageId),
            "created-at": _unref(createdAt),
            "is-you": _unref(isYou),
            metadata: attachment.metadata,
            tag: 'div',
            class: "preview-message-file-list",
            onShowPreview: openFilePreview
          }, null, 8, ["file", "document-id", "message-id", "created-at", "is-you", "metadata"]))
        }), 128))
      ], 2)
    ]),
    _createVNode(PreviewFileModal, {
      visible: showPreviewModal.value,
      title: "Preview File",
      onCancel: closeFilePreview
    }, null, 8, ["visible"])
  ], 2))
}
}

})